module.exports = __webpack_public_path__ + "img/nasiv-summit-logo.e69ef3d0.svg";